import "./footer.scss";
import "./footer-scroll-fix.scss"; // Import additional scroll fixes
import { useContext } from 'react';
import {CoursesContext} from '../../context/CoursesContext';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { faPhone } from "@fortawesome/free-solid-svg-icons";
import { faLocationPin } from "@fortawesome/free-solid-svg-icons";
import PrivacyPolicyLink from '../common/PrivacyPolicyLink';
import ScrollToTopLink from '../common/ScrollToTopLink';
import ScrollToTopExternalLink from '../common/ScrollToTopExternalLink';
import ContactLink from '../common/ContactLink';
function Footer(props) {
    const { categoryDetails } = useContext(CoursesContext);
    const midpoint = Math.ceil(categoryDetails.length / 2);
    const categoriesColumn1 = categoryDetails.slice(0, midpoint); // First half (extra item if odd)
    const categoriesColumn2 = categoryDetails.slice(midpoint); // Second half
    const links = [
        { name: "Home", url: "/" },
        { name: "Training", url: "/training" },
        { name: "Consultancy", url: "/consulting" },
        { name: "EdTech Solutions", url: "/edtech" },
        // Contact link is handled separately with a special component
        { name: "Contact", url: "/contact", isContactPage: true },
        { name: "Altova", url: "/altova" },
        { name: "About Us", url: "/about" },
        // Privacy Policy is handled separately with a special component
        { name: "Privacy Policy", url: "/privacy-policy", isPrivacyPolicy: true }
    ];

    return (
        <div className="footer">
            <div className="footer--mission">
                <img src="/assets/images/watchelmlogo-with-strap.svg" alt="Watchelm Logo" className="img-fluid" />
                <div className="footer--mission--statement">
                    We help corporate bodies, SMEs and public sector organisations
                    who need to fill technical skills gaps and solve business problems
                    using our high-quality training, consulting and EdTech services
                </div>
                <hr className="footer--hr" />
                <div className="footer--mission--small-print">
                    &copy; Watch Elm Consulting Ltd {new Date().getFullYear()} | Company No. 16285610 | VAT No. GB 488264054
                </div>
            </div>
           
            <div className="footer--links">
                <div className="footer--header">
                    Links
                </div>
                <hr className="footer--hr" />                <ul className="footer--links--list">                    {links.map((link, index) => (
                        <li key={index}>
                            {link.isPrivacyPolicy ? (
                                <PrivacyPolicyLink>{link.name}</PrivacyPolicyLink>
                            ) : link.isContactPage ? (
                                <ContactLink>{link.name}</ContactLink>
                            ) : (
                                <ScrollToTopLink to={link.url}>{link.name}</ScrollToTopLink>
                            )}
                        </li>
                    ))}
                </ul>                
            </div>
            <div className="footer--links">
                <div className="footer--header">
                    Course Categories
                </div>
                <hr className="footer--hr" />                <ul className="footer--links--list">                    {categoriesColumn1.map((category, index) => (
                        <li key={index}>
                            <ScrollToTopLink to={"/categories/"+category.category}>{category.title}</ScrollToTopLink>
                        </li>
                    ))}
                </ul>                
            </div>
            <div className="footer--links">
                <div className="footer--header">
                    &nbsp;
                </div>
                <hr className="footer--hr" />                <ul className="footer--links--list">                    {categoriesColumn2.map((category, index) => (
                        <li key={index}>
                            <ScrollToTopLink to={"/categories/"+category.category}>{category.title}</ScrollToTopLink>
                        </li>
                    ))}
                </ul>                
            </div>
            <div className="footer--links">
                <div className="footer--header">
                    Contact Us
                </div>
                <hr className="footer--hr" />                <ul className="footer--links--list">                   <li>
                        <FontAwesomeIcon icon={faPhone}/> 
                        <ScrollToTopExternalLink href="tel:+441174417005">
                            +44 (0) 117 4417005
                        </ScrollToTopExternalLink>
                    </li>
                   <li>
                        <FontAwesomeIcon icon={faEnvelope}/>
                        <ScrollToTopExternalLink href="mailto:enquiries@watchelm.com">
                            enquiries@watchelm.com
                        </ScrollToTopExternalLink>
                    </li>
                   <li><FontAwesomeIcon icon={faLocationPin} />  Watch Elm Close</li>
                   <li className="footer--links--list--indent">Bristol</li>
                   <li className="footer--links--list--indent">BS32 8AL</li>
                   <li className="footer--links--list--indent">United Kingdom</li>
                </ul>                
            </div>
        </div>
    );

}

export default Footer;